import { v4 } from 'uuid';
import download from 'downloadjs';

import { dispatchRequestInfo, executeTwoStepEventQueries } from './execute';
import {
  buildCsvQueries,
  fromEventCsvResponse,
  getEventsCsvInfo,
} from '../converters/eventCsvApiConverter';
import { CSV_FILE_DESCRIPTION } from '../utils/csv';
import { applyCache } from '../utils/event/cacheHandler';
import { TABS } from '../constants/navigation';
import { getEvents } from '../reducers/analyticsApp';

const executeEventQueriesCsv = () => (dispatch, getState) => {
  const state = getState();
  const csvQueries = buildCsvQueries(state);
  const executeId = v4();
  const eventsCsvInfo = getEventsCsvInfo(state);
  const events = getEvents(state);

  dispatchRequestInfo(
    executeId,
    dispatch,
    TABS.EVENTS.title,
    events.map(({ name }) => name),
    true
  );

  const execute = (queries) => executeTwoStepEventQueries(queries, executeId, dispatch, getState);

  return applyCache(csvQueries, execute, dispatch, getState)
    .then((response) => fromEventCsvResponse(response, csvQueries, eventsCsvInfo))
    .then((mappedResult) =>
      mappedResult.forEach(({ name, csv }) => {
        download(csv, name, CSV_FILE_DESCRIPTION);
      })
    );
};

export default executeEventQueriesCsv;
